import { groupTimezone } from "@/helpers/timezones";
import axios from "axios";

const state = () => ({
  timezones: {},
  loading: false,
  errors: [],
});

const mutations = {
  SET_TIMEZONES(state, data) {
    state.timezones = data;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERRORS(state, errors) {
    state.errors = errors;
  },
};

const getters = {
  getTimezones: (state) => {
    return state.timezones;
  },
  isLoading: (state) => {
    return state.loading;
  },
  getErrors: (state) => {
    return state.errors;
  },
};

const actions = {
  async fetchTimezones({ commit }) {
    commit("SET_LOADING", true);
    const url = `${process.env.VUE_APP_API_URL}/tm/utilities/timezones`;
    const headers = {
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
    };

    try {
      const response = await axios.get(url, { headers });
      const timezonesGroup = groupTimezone(response.data);
      commit("SET_TIMEZONES", timezonesGroup);
      commit("SET_ERRORS", []);
    } catch (error) {
      commit("SET_TIMEZONES", {});
      commit(
        "SET_ERRORS",
        error.response?.data?.message ?? "Fetch Timezones failed."
      );
    } finally {
      commit("SET_LOADING", false);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
